import styled from 'styled-components';
import { borderRadius, smallShadow, spacing } from 'ui/theme';

export const StyledNBASuggestionCard = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: ${spacing.base};
  gap: ${spacing.half};
  border-radius: ${borderRadius.lg};
  ${smallShadow};
`;

export const Recommendations = styled.div`
   margin-bottom: ${spacing.half};
`;
